import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { MailService } from '../mail.service';
import { MatDialog } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { StateService } from 'src/app/services/states.service';
import { CustomerService } from 'src/app/services/customer.service';
import { LoginComponent } from 'src/app/partials/login/login.component'; 
import { DialogCommonError } from 'src/app/views/dialogs-errors/dialog-common-error.component'; 
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    constructor(
        private dialog: MatDialog,
        private appService: AppService,
        private mailService: MailService,
        private customerService: CustomerService,
        private cookies: CookieService,
        private stateService: StateService,
    ) {}

    sendMailAbbyyError() {
        let textError = 
        "Rupture by Cobham rencontre un problème sur l’un de ses serveurs." 
        + "\n" +
        "L'équipe technique a été avertie et nous reviendrons vers vous le plus rapidement possible."
        + "\n\n" + 
        "Pour tout complément d’informations sur le problème que vous rencontrez, nous vous invitons à nous contacter en envoyant un mail à support@cobham-solutions.com"
        + "\n\n" + 
        "L\'équipe Rupture by Cobham.";
        this.openDialogError(textError);
        
        // mailBody à faire si besoin
        this.mailService.sendMailToSupport("Erreur Abbyy", "mailBody").subscribe((res) => {});
    }

    openDialogError(textError: string) {
        this.dialog.open(DialogCommonError, {
            width: '100%',
            panelClass:'error-dialog',
            data : textError
        });
    }

    errorHandling(response){
        if (response.error) {            
            if (response.code == 401) {
                this.dialog.open(LoginComponent, {
                    height: '55%',
                    width: '25%',
                    panelClass:'dialog-login'
                })
            }
        }
        return response.error ? response.error : "";
    }
}